import { Global } from "@emotion/react";

const Fonts = () => (
  <Global
    styles={`
      /* Local font faces */

      /* new spirit */
      @font-face {
        font-family: 'New Spirit';
        font-style: normal;
        font-weight: 400;
        src: url('/fonts/New Spirit Regular.otf') format('opentype'), url('/fonts/New Spirit Bold.otf') format('opentype')
      }
      /* plus jakarta sans */
      @font-face {
        font-family: 'Plus Jakarta Sans';
        font-style: normal;
        font-weight: 400;
      src: url('/fonts/PlusJakartaSans-Regular.ttf') format('truetype'), url('/fonts/PlusJakartaSans-Medium.ttf') format('truetype'), url('/fonts/PlusJakartaSans-Bold.ttf') format('truetype')
      }
      /* Snell */
      @font-face {
        font-family: 'Snell';
        font-style: normal;
        font-weight: 400;
      src: url('/fonts/SnellBT-Regular.otf')
      }
      /* Gopher */
      @font-face {
        font-family: 'Gopher';
        font-style: normal;
        font-weight: 400;
      src: url('/fonts/GopherDisplay-Regular.ttf') format('truetype'), url('/fonts/GopherDisplay-Medium.ttf') format('truetype')
      }
      /* Glacial Regular */
      @font-face {
        font-family: 'Glacial';
        font-style: normal;
        font-weight: 400;
        src: url('/fonts/GlacialIndifference-Regular.otf') format('opentype')
      }
      /* Glacial Bold */
      @font-face {
        font-family: 'Glacial';
        font-style: normal;
        font-weight: 700;
        src: url('/fonts/GlacialIndifference-Bold.otf') format('opentype')
      }
      /* GlacialBold (separate family name for compatibility) */
      @font-face {
        font-family: 'GlacialBold';
        font-style: normal;
        font-weight: 400;
        src: url('/fonts/GlacialIndifference-Bold.otf') format('opentype')
      }
    `}
  />
);

export default Fonts;
